// Auto-generated from ErrorNameEnum

export const errorName = {
  accountBlocked: 'accountBlocked',
  adminMembershipProtected: 'adminMembershipProtected',
  badRequest: 'badRequest',
  createFailure: 'createFailure',
  dataCollectionError: 'dataCollectionError',
  dataConcurrencyError: 'dataConcurrencyError',
  dataCreationError: 'dataCreationError',
  dataDeleteError: 'dataDeleteError',
  dataNotFoundError: 'dataNotFoundError',
  dataUpdateConcurrencyError: 'dataUpdateConcurrencyError',
  dataUpdateError: 'dataUpdateError',
  deleteFailure: 'deleteFailure',
  creditTypeInUse: 'creditTypeInUse',
  deleteNotAllowedHistory: 'deleteNotAllowedHistory',
  domainNotFoundError: 'domainNotFoundError',
  domainSuspended: 'domainSuspended',
  domainUserAlreadyExistsError: 'domainUserAlreadyExistsError',
  duplicateValueError: 'duplicateValueError',
  email: 'email',
  emailNotConfirmed: 'emailNotConfirmed',
  emptyKeyError: 'emptyKeyError',
  functionAssignNotAllowed: 'functionAssignNotAllowed',
  fileNotFoundError: 'fileNotFoundError',
  gatewayTimeout: 'gatewayTimeout',
  getListFailure: 'getListFailure',
  getDetailsFailure: 'getDetailsFailure',
  insufficientCredits: 'insufficientCredits',
  internalServerError: 'internalServerError',
  invalidAutocompleteObject: 'invalidAutocompleteObject',
  invalidAutocompleteString: 'invalidAutocompleteString',
  invalidEmailOrPassword: 'invalidEmailOrPassword',
  invalidTwoFactorCode: 'invalidTwoFactorCode',
  invitationAlreadyOpenError: 'invitationAlreadyOpenError',
  keyNotFoundError: 'keyNotFoundError',
  missingArgument: 'missingArgument',
  missingAuthorization: 'missingAuthorization',
  missingDatabaseConnection: 'missingDatabaseConnection',
  missingNetworkConnection: 'missingNetworkConnection',
  serverUnreachable: 'serverUnreachable',
  missingToken: 'missingToken',
  noAccount: 'noAccount',
  notFound: 'notFound',
  ownerMembershipProtected: 'ownerMembershipProtected',
  pageNotFoundError: 'pageNotFoundError',
  periodClosed: 'periodClosed',
  periodDateInPast: 'periodDateInPast',
  missingPattern: 'missingPattern',
  restoreFailure: 'restoreFailure',
  required: 'required',
  selfEndNotAllowed: 'selfEndNotAllowed',
  tokenMissing: 'tokenMissing',
  tokenRequested: 'tokenRequested',
  tokenSaveError: 'tokenSaveError',
  twoFactorDisableNotAllowed: 'twoFactorDisableNotAllowed',
  twoFactorNotEnabled: 'twoFactorNotEnabled',
  twoFactorRequired: 'twoFactorRequired',
  unAuthorized: 'unAuthorized',
  unknowEmailOrPassword: 'unknowEmailOrPassword',
  unknownUser: 'unknownUser',
  updateFailure: 'updateFailure',
  uploadLimitReached: 'uploadLimitReached',
  userPhotoRequiresActiveDomain: 'userPhotoRequiresActiveDomain',
  validationError: 'validationError',
  wrongEmailAddress: 'wrongEmailAddress',
}

export type TErrorName = (typeof errorName)[keyof typeof errorName];
